export default "__VITE_ASSET__Ce0j$r3k__"